import { __DetectCountry } from './detect-country/types';
import { detectCountry, detectCountryFor } from './detect-country';
import type { CountryCode } from '../location-detection';

/**
 * Field Context Helpers
 *
 * Provides built-in context detection functions for dynamic field options.
 * Users can access these via the second parameter in dynamicOptions functions.
 */

export interface __FieldContextHelpers {
  detectCountry: (
    text: string,
    options?: { threshold?: number }
  ) => __DetectCountry.__CountryDetectionResult;
  detectCountryFor: (
    text: string,
    country: __DetectCountry.__SupportedCountry,
    options?: { threshold?: number }
  ) => { match: boolean; confidence: number };
  // User's detected country code from IP geolocation
  userCountryCode?: CountryCode;
  // Future: add more helpers and extend SupportedCountry beyond 'US' | 'UK'
}

export const createFieldContextHelpers = (userCountryCode?: CountryCode): __FieldContextHelpers => ({
  detectCountry,
  detectCountryFor,
  userCountryCode,
});

// Legacy export for backwards compatibility
export const fieldContextHelpers: __FieldContextHelpers = {
  detectCountry,
  detectCountryFor,
};
